// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__JONwY","menuClose":"MainNavigation_menuClose__p52P7","menuOpen":"MainNavigation_menuOpen__RMFSI"};